import * as types from "../types";

export const getCongress = () => ({
  type: types.GET_CONGRESS,
  request: {
    url: "/congresses/current",
    method: "GET"
  }
});
